import { jsx, jsxs } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import './FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

/**
 * Footer component for page-level actions or metadata
 * @param children - Footer content (used if left/center/right not provided)
 * @param className - Additional CSS classes
 * @param border - Whether to show top border
 * @param left - Content for left area
 * @param center - Content for center area
 * @param right - Content for right area
 * @returns JSX element with footer layout
 */
const PageFooter = ({ children, className, border = true, left, center, right, }) => {
    // If left/center/right are provided, use three-column layout
    const hasExplicitAreas = left || center || right;
    return (jsx("footer", { className: cn('mt-auto pt-6', border && 'border-t', className), children: hasExplicitAreas ? (jsxs("div", { className: "flex items-center justify-between", children: [jsx("div", { className: "flex-1", children: left }), center && jsx("div", { className: "flex-1 flex justify-center", children: center }), jsx("div", { className: "flex-1 flex justify-end", children: right })] })) : (children) }));
};

export { PageFooter };
//# sourceMappingURL=PageFooter.js.map
